import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { AuthContextProvider } from './context/authenticationContext'

// Why is <React.StrictMode> disabled?
// GitHub issue regarding React strict mode warning (findDOMNode deprecation)
// https://github.com/mui-org/material-ui/issues/13394

ReactDOM.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </BrowserRouter>,
  // </React.StrictMode>
  document.getElementById('root'),
)
reportWebVitals()
